import publicAxiosInstance from "../utils/API";

const getCommentaires = (demandeId) => {
    return publicAxiosInstance.get(`/Demande/${demandeId}/commentaires`);
};
const addCommentaire = (payload) => {
    return publicAxiosInstance.post('/Demande/commentaire', payload);
};
export { addCommentaire, getCommentaires };
